<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <h3 v-if="existenDatosPersonaVisita == false" style="text-align: left;">Usar misma persona que en datos de la instalación</h3>
    <div class="py-3" style="text-align: left;" v-if="existenDatosPersonaVisita == false">
        <button type="button"   class="btn btn-dark" @click="sinscronizarInformacion">Usar Información de datos de Instalación</button>

    </div>

   <hr>


    <h3 style="text-align: left;">Información General</h3>
    
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.nombre }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Telefono</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.telefono" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.telefono }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Email</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.email" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.email }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Curp</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.curp" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.curp }}</label>
            </div>
        </div>
    </div>
    <hr>
    <h3>Domicilio</h3>
    
    
    <div >
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Calle</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.calle"/>
                <label class="is-invalid">{{ validation.calle }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Numero exterior</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero_exterior"/>
                <label class="is-invalid">{{ validation.numero_exterior }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Numero interior</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero_interior"/>
                <label class="is-invalid">{{ validation.numero_interior }}</label>
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Colonia</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.colonia"/>
                <label class="is-invalid">{{ validation.colonia }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Codigo postal</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.codigo_postal"/>
                <label class="is-invalid">{{ validation.codigo_postal }}</label>
            </div>
            
            <div class="col-md-4">
                <label for="">Municipio</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.municipio"/>
                <label class="is-invalid">{{ validation.municipio }}</label>
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Estado</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.estado"/>
                <label class="is-invalid">{{ validation.estado }}</label>
            </div>
        </div>
        
    </div>
    <button type="button" v-if="existenDatosPersonaVisita == false" class="btn btn-dark" @click="guardar">Guardar informacion de la persona que atiende la visita</button>
    <button type="button" v-if="existenDatosPersonaVisita == true" class="btn btn-warning" @click="actualizar">Actualizar informacion de la persona que atiende la visita</button>
    
    
    </template>
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                isLoading:false,
                isButton1Disabled: false,
                isButton2Disabled: true,
                form:{
                    nombre:'',
                    telefono:'',
                    email:'',
                    curp:'',
                    calle:'',
                    numero_exterior:'',
                    numero_interior:'',
                    colonia:'',
                    codigo_postal:'',
                    municipio:'',
                    estado:'',
                    idcotizacion:""
                },
                existenDatosPersonaVisita:false,
                id:'',
                validation:{
                    nombre:'',
                    telefono:'',
                    email:'',
                    calle:'',
                    numero_exterior:'',
                    numero_interior:'',
                    colonia:'',
                    codigo_postal:'',
                    municipio:'',
                    estado:'',
                    curp:'',
                }
            }  
        },
        created() {
            this.consultarRegistros();
        },
        methods: {
            selectButton(buttonNumber) {
                if (buttonNumber === 1) {
                    this.isButton2Disabled = true;
                    this.isButton1Disabled = false;
                    document.getElementById('personaMoral').style.display = 'none';
                    document.getElementById('personaFisica').style.display = 'block';
                } else if (buttonNumber === 2) {
                    
                    this.isButton1Disabled = true;
                    this.isButton2Disabled = false;
                    document.getElementById('personaMoral').style.display = 'block';
                    document.getElementById('personaFisica').style.display = 'none';
    
    
                }
            },
            sinscronizarInformacion(){
                this.isLoading = true;
                var idcotizacion = localStorage.getItem('idcotizacion');
                
                axios.post(this.$rutaServer+'sincronizarInformacion',{idcotizacion:idcotizacion})
                .then(response => {
                   if(response.status == 200){
                    this.isLoading = false;
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.consultarRegistros();
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    /*if(error.response.data.errors?.razon_social?.[0]){
                        this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                    }
                    if(error.response.data.errors?.nombre_representante?.[0]){
                        this.validation.nombre_representante = error.response.data.errors?.nombre_representante?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                        this.validation.direccion = error.response.data.errors?.direccion?.[0];
                    }
                    if(error.response.data.errors?.capacidad?.[0]){
                        this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
                    }*/
                });
            },
            guardar(){
                var idcotizacion = localStorage.getItem('idcotizacion');
                this.form.idcotizacion = idcotizacion;
                axios.post(this.$rutaServer+'registrar', this.form)
                .then(response => {
                   if(response.status == 201){
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';
                        this.consultarRegistros();
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    Swal.fire('error!', 'Todos los campos son requeridos', 'error');
                    if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
                    if(error.response.data.errors?.calle?.[0]){
                        this.validation.calle = error.response.data.errors?.calle?.[0];
                    }
                    if(error.response.data.errors?.numero_exterior?.[0]){
                        this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                    }
                    if(error.response.data.errors?.numero_interior?.[0]){
                        this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                    }
                    if(error.response.data.errors?.colonia?.[0]){
                        this.validation.colonia = error.response.data.errors?.colonia?.[0];
                    }
                    if(error.response.data.errors?.codigo_postal?.[0]){
                        this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                    }
                    if(error.response.data.errors?.municipio?.[0]){
                        this.validation.municipio = error.response.data.errors?.municipio?.[0];
                    }
                    if(error.response.data.errors?.estado?.[0]){
                        this.validation.estado = error.response.data.errors?.estado?.[0];
                    }
                    if(error.response.data.errors?.curp?.[0]){
                        this.validation.curp = error.response.data.errors?.curp?.[0];
                    }
                    /*if(error.response.data.errors?.direccion?.[0]){
                        this.validation.direccion = error.response.data.errors?.direccion?.[0];
                    }
                    if(error.response.data.errors?.capacidad?.[0]){
                        this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
                    }*/
                });
            },
            actualizar(){
                axios.post(this.$rutaServer+'actualizarPersonaVisita', this.form)
                .then(response => {
                   if(response.status == 200){
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    Swal.fire('error!', 'Todos los campos son requeridos', 'error');

                    if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
                    if(error.response.data.errors?.calle?.[0]){
                        this.validation.calle = error.response.data.errors?.calle?.[0];
                    }
                    if(error.response.data.errors?.numero_exterior?.[0]){
                        this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                    }
                    if(error.response.data.errors?.numero_interior?.[0]){
                        this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                    }
                    if(error.response.data.errors?.colonia?.[0]){
                        this.validation.colonia = error.response.data.errors?.colonia?.[0];
                    }
                    if(error.response.data.errors?.codigo_postal?.[0]){
                        this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                    }
                    if(error.response.data.errors?.municipio?.[0]){
                        this.validation.municipio = error.response.data.errors?.municipio?.[0];
                    }
                    if(error.response.data.errors?.estado?.[0]){
                        this.validation.estado = error.response.data.errors?.estado?.[0];
                    }
                    if(error.response.data.errors?.curp?.[0]){
                        this.validation.curp = error.response.data.errors?.curp?.[0];
                    }
                    /*if(error.response.data.errors?.razon_social?.[0]){
                        this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                    }
                    if(error.response.data.errors?.nombre_representante?.[0]){
                        this.validation.nombre_representante = error.response.data.errors?.nombre_representante?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                        this.validation.direccion = error.response.data.errors?.direccion?.[0];
                    }
                    if(error.response.data.errors?.capacidad?.[0]){
                        this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
                    }*/
                });
            },
            consultarRegistros(){
                this.isLoading = true;
                this.form.idcotizacion = localStorage.getItem('idcotizacion');
                axios.post(this.$rutaServer+'consultarPersonaVisita', this.form)
                .then(response => {
                   if(response.status == 200){
                    this.isLoading = false;
                        if(response.data.length > 0){
                            this.existenDatosPersonaVisita = true;
                        }
                        this.form.nombre = response.data[0].nombre;
                        this.form.email = response.data[0].email;
                        this.form.telefono = response.data[0].telefono;
                        this.form.calle = response.data[0].calle;
                        this.form.numero_exterior = response.data[0].numero_exterior;
                        this.form.numero_interior = response.data[0].numero_interior;
                        this.form.colonia = response.data[0].colonia;
                        this.form.codigo_postal = response.data[0].codigo_postal;
                        this.form.municipio = response.data[0].municipio;
                        this.form.estado = response.data[0].estado;
                        this.form.idcotizacion = response.data[0].idcotizacion;
                        this.form.id = response.data[0].id;
                        this.form.curp = response.data[0].curp;

                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    /*if(error.response.data.errors?.razon_social?.[0]){
                        this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                    }
                    if(error.response.data.errors?.nombre_representante?.[0]){
                        this.validation.nombre_representante = error.response.data.errors?.nombre_representante?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                        this.validation.direccion = error.response.data.errors?.direccion?.[0];
                    }
                    if(error.response.data.errors?.capacidad?.[0]){
                        this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
                    }*/
                });
            }
        },
            
    };
    </script>